module.exports = __webpack_public_path__ + "img/skillset-gfx.bbb069d7.png";